import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


export default function OrderManagement() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [filterText, setFilterText] = useState("");

    // Pagination states
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  
     const mockOrders = [
    {
        orderId: 1,
        userId: 101,
        userName: "John Doe",
        orderNumber: "ORD-2023-001",
        orderDate: "2023-09-01T10:00:00Z",
        totalAmount: 95.00,
        taxAmount: 5.00,
        shippingCost: 10.00,
        grandTotal: 110.00,
        currencyId: 1,
        items: [
            { orderItemId: 1, productId: 10, quantity: 2, productVariantId: 100, orderId: 1, unitPrice: 25.00, discountApplied: 0, subtotal: 50.00 },
            { orderItemId: 2, productId: 11, quantity: 1, productVariantId: 101, orderId: 1, unitPrice: 45.00, discountApplied: 0, subtotal: 45.00 }
        ],
        payments: [
            { paymentId: 1, orderId: 1, paymentStatusId: 1, paymentMethodId: 1, gatewayTransactionId: "TXN-A1B2C3", amountPaid: 110.00, currency: "USD", paymentDate: "2023-09-01T10:01:00Z" }
        ],
        shippingAddress: {
            addressId: 1,
            street: "123 Main St",
            city: "Anytown",
            state: "CA",
            postalCode: "12345",
            country: "USA"
        },
        orderStatusId: 1,
        orderStatus: "Shipped"
    },
    // Add more mock orders here
    {
        orderId: 2,
        userId: 102,
        userName: "Jane Smith",
        orderNumber: "ORD-2023-002",
        orderDate: "2023-09-02T11:30:00Z",
        totalAmount: 120.00,
        taxAmount: 6.00,
        shippingCost: 8.00,
        grandTotal: 134.00,
        currencyId: 1,
        items: [
            { orderItemId: 3, productId: 12, quantity: 3, productVariantId: 102, orderId: 2, unitPrice: 40.00, discountApplied: 0, subtotal: 120.00 }
        ],
        payments: [
            { paymentId: 2, orderId: 2, paymentStatusId: 1, paymentMethodId: 2, gatewayTransactionId: "TXN-D4E5F6", amountPaid: 134.00, currency: "USD", paymentDate: "2023-09-02T11:31:00Z" }
        ],
        shippingAddress: {
            addressId: 2,
            street: "456 Oak Ave",
            city: "Someton",
            state: "NY",
            postalCode: "67890",
            country: "USA"
        },
        orderStatusId: 2,
        orderStatus: "Processing"
    }
];
  
  const [formData, setFormData] = useState({
    orderId: null,
    userId: null,
    userName: "",
    orderNumber: "",
    totalAmount: 0,
    taxAmount: 0,
    shippingCost: 0,
    grandTotal: 0,
    currencyId: null,
    orderStatusId: null,
    items: [],
    payments: [],
    shippingAddress: null,
  });

  // Fetch all orders
  const fetchOrders = async () => {
    setLoading(true);
       //   setOrders(mockOrders);
      // setRowCount(mockOrders.totalElements);
    try {
      const res = await axiosInstance.get(`${backendUrl}/api/orders`, {
        params: { page, size: pageSize },
    });
    //  setOrders(res.data);


      setOrders(res.data.content);   
       setRowCount(res.data.totalElements);
    } catch (err) {
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [page, pageSize]);

  const handleOpen = (order = null) => {
    if (order) {
      setFormData(order);
    } else {
      setFormData({
        orderId: null,
        userId: null,
        userName: "",
        orderNumber: "",
        totalAmount: 0,
        taxAmount: 0,
        shippingCost: 0,
        grandTotal: 0,
        currencyId: null,
        orderStatusId: null,
        items: [],
        payments: [],
        shippingAddress: null,
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrder(null);
  };

  const handleSave = async () => {
    try {
      if (formData.orderId) {
        await axiosInstance.put(`/api/orders/${formData.orderId}`, formData);
      } else {
        await axiosInstance.post("/api/orders", formData);
      }
      fetchOrders();
      handleClose();
    } catch (err) {
      console.error("Error saving order:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this order?")) {
      try {
        await axiosInstance.delete(`/api/orders/${id}`);
        fetchOrders();
      } catch (err) {
        console.error("Error deleting order:", err);
      }
    }
  };

  const handleView = (order) => {
    setSelectedOrder(order);
  };

  const handleOrderItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index][field] = value;
    setFormData({ ...formData, items: updatedItems });
  };

  const filteredOrders = orders.filter(
    (o) =>
      o.orderNumber.toLowerCase().includes(filterText.toLowerCase()) ||
      o.userName.toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    { field: "orderId", headerName: "ID", width: 100 },
    { field: "orderNumber", headerName: "Order #", flex: 1 },
    { field: "userName", headerName: "Customer", flex: 1 },
    { field: "grandTotal", headerName: "Grand Total", flex: 1 },
    { field: "orderStatus", headerName: "Status", flex: 1 },
    {
      field: "shippingAddress",
      headerName: "Address",
      flex: 2,
      valueGetter: (params) =>
        params.row.shippingAddress
          ? `${params.row.shippingAddress.street1}, ${params.row.shippingAddress.street2},  ${params.row.shippingAddress.city} -  ${params.row.shippingAddress.postalCode}`
          : "N/A",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <>
          <IconButton color="secondary" onClick={() => handleView(params.row)}>
            <Visibility />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>Order Management</h2>

      <div style={{ marginBottom: 10 }}>
        <TextField
          label="Filter"
          variant="outlined"
          size="small"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{ marginRight: 10 }}
        />
        <Button variant="contained" color="primary" onClick={() => handleOpen()}>
          Add New Order
        </Button>
      </div>

      <div style={{ height: 500, width: "100%" }}>
      {/*  <DataGrid
          rows={filteredOrders}
          getRowId={(row) => row.orderId}
          columns={columns}
          pageSize={5}
          loading={loading}
        />  */}
         <DataGrid
          rows={orders}
          getRowId={(row) => row.orderId}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newSize) => {
            setPageSize(newSize);
            setPage(0); // reset to first page
          }}
          loading={loading}
        />
      </div>

      {/* Add/Edit Order Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{formData.orderId ? "Edit Order" : "Add Order"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Order Number"
            fullWidth
            value={formData.orderNumber}
            onChange={(e) => setFormData({ ...formData, orderNumber: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Customer Name"
            fullWidth
            value={formData.userName}
            onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
          />

          <Typography variant="h6" style={{ marginTop: 20 }}>
            Order Items
          </Typography>
          {formData.items.map((item, index) => (
            <Box key={index} sx={{ border: "1px solid #ccc", p: 1, mb: 1 }}>
              <TextField
                label="Product ID"
                value={item.productId}
                onChange={(e) =>
                  handleOrderItemChange(index, "productId", e.target.value)
                }
                style={{ marginRight: 10 }}
              />
              <TextField
                label="Quantity"
                type="number"
                value={item.quantity}
                onChange={(e) =>
                  handleOrderItemChange(index, "quantity", e.target.value)
                }
                style={{ marginRight: 10 }}
              />
              <TextField
                label="Unit Price"
                type="number"
                value={item.unitPrice}
                onChange={(e) =>
                  handleOrderItemChange(index, "unitPrice", e.target.value)
                }
              />
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Details Dialog */}
      <Dialog open={!!selectedOrder} onClose={() => setSelectedOrder(null)} maxWidth="md" fullWidth>
        <DialogTitle>Order Details</DialogTitle>
        <DialogContent>
          {selectedOrder && (
            <>
              <p><b>Order #:</b> {selectedOrder.orderNumber}</p>
              <p><b>Customer:</b> {selectedOrder.userName}</p>
            <p><b>Order Date:</b> {selectedOrder.orderDate}</p>
              <p><b>Order Status:</b> {selectedOrder.orderStatus}</p>
              <p><b>Tax Total:</b> {selectedOrder.taxAmount}</p>
              <p><b>Discount Total:</b> {selectedOrder.discountTotal}</p>
           <p><b>Coupon Total:</b> {selectedOrder.couponTotal}</p>
             <p><b>Coupon Code:</b> {selectedOrder.couponCode}</p>
           
              <p><b>Grand Total:</b> {selectedOrder.grandTotal}</p>
           
              <Typography variant="h6">Shipping Address</Typography>
              <p>
                {selectedOrder.shippingAddress
                  ? `${selectedOrder.shippingAddress.street1}, ${selectedOrder.shippingAddress.street2}, ${selectedOrder.shippingAddress.city}, ${selectedOrder.shippingAddress.state} -  ${selectedOrder.shippingAddress.postalCode}`
                  : "N/A"}
              </p>

              <Typography variant="h6">Items</Typography>
              {selectedOrder.items?.map((item) => (
                <p key={item.orderItemId}>
                  {item.productName}  / {item.productVariantName} - Qty: {item.quantity} - Price: {item.unitPrice} 
                  Discount: {item.discountApplied}  / {item.couponApplied} - Tax: {item.taxCharged} - Total Price: {item.subtotal} 
                </p>
              ))}

              <Typography variant="h6">Payments</Typography>
              {selectedOrder.payments?.map((p) => (
                <p key={p.paymentId}>
                  {p.paymentMethodId} - {p.amountPaid} {p.currency} on{" "}
                  {new Date(p.paymentDate).toLocaleDateString()}
                </p>
              ))}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedOrder(null)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
